import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API } from "../../config/config";
import toast from "react-hot-toast";

export const fetchComplaints = createAsyncThunk(
  "complaints/fetchComplaints",
  async (buildingId: string, { rejectWithValue }) => {
    try {
      const response = await API.GET(`/complaints/ByBuilding/${buildingId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateComplaintStatus = createAsyncThunk(
  "complaints/updateComplaintStatus",
  async ({ complaintId, status }: any, { rejectWithValue }) => {
    try {
      await API.PUT(`/complaints/${complaintId}`, { status });
      toast.success("Complaint status updated successfully");
      return { complaintId, status };
    } catch (error: any) {
      toast.error("Error updating complaint status");
      return rejectWithValue(error.response.data);
    }
  }
);

const complaintsSlice = createSlice({
  name: "complaints",
  initialState: {
    complaints: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchComplaints.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchComplaints.fulfilled, (state, action) => {
        state.loading = false;
        state.complaints = action.payload;
      })
      .addCase(fetchComplaints.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as any;
      })
      .addCase(updateComplaintStatus.fulfilled, (state, action) => {
        const { complaintId, status } = action.payload;
        const complaint: any = state.complaints.find(
          (comp: any) => comp._id === complaintId
        );
        if (complaint) complaint.status = status;
      });
  },
});

export default complaintsSlice.reducer;
